import { shallowReactive as i } from "vue";
const s = i(
  {}
), u = (t) => (s[t] || (s[t] = i([])), s[t]), d = (t, e) => {
  const n = s[e] || [], c = n.findIndex((a) => a.id === t), o = n[c];
  let r;
  return c > 0 && (r = n[c - 1]), { current: o, prev: r };
}, x = (t, e) => {
  const { prev: n } = d(t, e);
  return n ? n.vm.exposed.bottom.value : 0;
}, p = (t, e, n) => (s[n] || []).findIndex((r) => r.id === t) > 0 ? 16 : e;
export {
  d as getInstance,
  x as getLastOffset,
  p as getOffsetOrSpace,
  u as getOrCreatePlacementInstances,
  s as placementInstances
};
